import axios from "axios";
import { useEffect, useState } from "react";
import LoadingDots from "./LoadingDots";
import bot from "../images/happy.png";
import you from "../images/boy.png";
import PropertyType from "./PropertyType";

const RequestACall = ({ siteId }) => {
  const [time] = useState(new Date());
  const [loading, setLoading] = useState(false);
  const [showFrame, setShowFrame] = useState(false);
  const [showFrame1, setShowFrame1] = useState(false);
  const [selectedDate, setSelectedDate] = useState("");
  const [showFrame2, setShowFrame2] = useState(false);
  const [time1] = useState(new Date());
  const [showFrame3, setShowFrame3] = useState(false);

  const handleShowFrame1 = () => {
    setShowFrame1(true);
    setShowFrame3(false);
  };

  const handleShowFrame2 = () => {
    setShowFrame3(true);
    setShowFrame1(false);
  };

  const handleSubmit = async () => {
    if (selectedDate && selectedDate.match(/^\d{4}-\d{2}-\d{2}$/)) {
      const today = new Date().toISOString().split('T')[0];

      if (selectedDate >= today) {
        setLoading(true);
        setShowFrame(false);
        setShowFrame2(false);

        try {
          const response = await axios.post("https://realestatechatbotapi.onrender.com/request_calls", {
            project_id: siteId,
            call_date: selectedDate,
          });

          if (response.status === 201) {
            setShowFrame2(true);
          } else {
            alert("Failed to submit. Please try again.");
          }
        } catch (error) {
          alert("Error: " + (error.response?.data?.error || "Failed to connect to the server."));
        } finally {
          setLoading(false);
        }
      } else {
        alert("Please select a present or future date.");
      }
    } else {
      alert("Please select a valid date");
    }
  };

  const handleKeyDown = (event) => {
    if (event.key === "Enter") {
      event.preventDefault();
      handleSubmit();
    }
  };

  return (
    <>
      <div className="you-time">
        <img src={you} alt="boy" className="boy" />
        You {time.toLocaleTimeString()}
      </div>

      <div className="you-message">
        <div className="frame2">Book a Site Visit</div>
      </div>

      <div className="chatbot">
        <img src={bot} alt="bot" className="bot" />
        <div className="chatbot-time"> {time.toLocaleTimeString()}</div>
      </div>

      <div>
        {loading ? (
          <div className="frame1">
            <LoadingDots />
          </div>
        ) : (
          <>
            <div className="frame1">
              <b>Akaay Infra:</b> Please select your preferred date
              <div style={{ display: 'flex', flexDirection: 'column', alignItems: 'center' }}>
                <input
                  type="date"
                  value={selectedDate}
                  className="input-text"
                  onChange={(e) => setSelectedDate(e.target.value)}
                  onKeyDown={handleKeyDown}
                  style={{ width: '300px', fontSize: '13px' }}
                  min={new Date().toISOString().split('T')[0]}
                />
              </div>
              <div style={{ textAlign: 'center', alignItems: 'center' }}>
                <button
                  className="date-submit-button"
                  onClick={handleSubmit}
                  style={{ width: '100px', fontSize: '13px' }}
                >
                  Submit
                </button>
              </div>
            </div>
          </>
        )}
      </div>

      {showFrame2 && (
        <>
          <div className="frame1">
            <b>Akaay Infra:</b> Your slot has been booked. Our team will give you a call soon.
          </div>
          <div className="frame1">
            Thank you! Is there anything else I can help you with?
            <div className="call-btns">
              <button onClick={handleShowFrame1}>Yes, start over.</button>
              <button onClick={handleShowFrame2}>No, I found what I needed.</button>
            </div>
          </div>
        </>
      )}

      {showFrame1 && (
        <>
          <div className="you-time">
            <img src={you} alt="boy" className="boy" />
            You {time1?.toLocaleTimeString()}
          </div>
          <div className="you-message">
            <div className="frame2"><b>Start Over</b></div>
          </div>
          <PropertyType />
        </>
      )}

      {showFrame3 && (
        <>
          <div className="you-time">
            <img src={you} alt="boy" className="boy" />
            You {time1?.toLocaleTimeString()}
          </div>
          <div className="you-message">
            <div className="frame2"><b>I found what I need</b></div>
          </div>
          <div className="chatbot">
            <img src={bot} alt="bot" className="bot" />
            <div className="chatbot-time"> {time.toLocaleTimeString()}</div>
          </div>
          <div className="frame1">
            Thank you for chatting with us today!
          </div>
        </>
      )}
    </>
  );
};

export default RequestACall;
